import FieldsTranslation from "graphql/fields/FieldsTranslation";

export default `
	guid
	position
	name
	can_book_for_self
	can_book_for_coworkers
	can_book_for_external
	can_only_book_single_timeslot_per_day
	show_capacity
	active
	
	timeslots_kinds {
		guid
	}
	
	translations {
		${FieldsTranslation}
	}
`;
